import {io} from 'socket.io-client'

const URL = process.env.VUE_APP_API_ENDPOINT

const socket = io(URL, {
  autoConnect: false,
  transports: ['websocket'],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  auth: {
    token: '',
  },
})

export default socket
